// const validatePhoneNumber = (phone: string) => {
//     const phoneRegex = /^([1-9]{1}[0-9]{1,14})$/;
//     return phoneRegex.test(phone);
// };
// const hasConsecutiveSubstring = (str: string, source: string, fieldName: string) => {
//     for (let i = 0; i < source?.length - 2; i++) {
//         const substring = source.substring(i, i + 3);
//         if (str.toLowerCase().includes(substring)) {
//             return `Password must not contain three consecutive characters from the ${fieldName} ('${substring}').`;
//         }
//     }
//     return null;
// };

// const validatePassword = (password, username = "", passwordHistory = []) => {

//     const commonWords = ["password", "admin", "welcome", "test123", "admin123", "qwerty", "letmein", "monkey", "abc123", "123456",
//         "12345678", "iloveyou", "sunshine", "princess", "football", "charlie", "donald", "freedom", "hello", "whatever",
//         "superman", "trustno1", "jordan", "killer", "summer", "computer", "batman", "qazwsx", "zaq1zaq1", "passw0rd",
//         "baseball", "soccer", "michael", "dragon", "mustang", "shadow", "master", "biteme", "starwars", "internet",
//         "merlin", "asdfgh", "hunter", "hockey", "george", "jessica", "pepper", "letmein1", "password1", "1qaz2wsx",
//         "123qwe", "welcome1", "admin1234", "login", "123123", "access", "654321", "321321", "football1", "7777777",
//         "cheese", "dallas", "lakers", "yankees", "robert", "tigger", "phoenix", "steelers", "banana", "whatever1",
//         "thomas", "ginger", "trustnoone", "pass123", "superman1", "batman1", "hockey1", "soccer1", "jordan1", "qwerty123",
//         "abc1234", "letmein123", "qazwsx123", "zaq1zaq1zaq1", "passw0rd1", "baseball1", "mustang1", "shadow1", "dragon1",
//         "hunter1", "merlin1", "asdfgh1", "internet1", "computer1", "starwars1", "jessica1", "george1", "pepper1",
//         "trustnoone1", "123456789", "987654321", "password123", "welcome123", "pass1234", "password321", "mypassword",
//         "newpassword", "changeme", "default", "unknown", "testing", "testtest", "sample", "asdf1234", "qwertyuiop",
//         "1234abcd", "abcd1234", "letmein2", "security", "securepass", "nopassword", "randompass", "guessme", "password999",
//         "iloveyou1", "sunshine1", "princess1", "football2", "charlie1", "donald1", "freedom1", "hello1", "whatever2",
//         "superman2", "trustno2", "jordan2", "killer1", "summer1", "computer2", "batman2", "qazwsx2", "zaq1zaq2", "passw0rd2"
//     ];
//     const minLength = 12;
//     const expiryDays = 90;
//     const maxFailedAttempts = 5;
//     const lockoutDuration = 24 * 60 * 60 * 1000;
//     const passwordReuseLimit = 8;


//     const rules = {
//         minLength: password?.length >= 12,
//         uppercase: /[A-Z]/.test(password),
//         lowercase: /[a-z]/.test(password),
//         number: /\d/.test(password),
//         specialChar: /[!@#$%^&*()]/.test(password),
//         // noCommonWords: !/(password|admin|welcome)/i.test(password),
//         // noUsernameSubstring: !password.includes(username),
//         noCommonWords: !commonWords.some(word => password.toLowerCase().includes(word)),
//         noUsernameSubstring: !new RegExp(username.slice(0, 4), "i").test(password),
//         notInHistory: !passwordHistory.includes(password),
//         expiryEnforced: true,
//         lockoutEnforced: true,
//         passwordReuseLimitExceeded: passwordHistory.length >= passwordReuseLimit
//     };

//     // Determine if all rules are satisfied
//     const isValid = Object.values(rules).every((rule) => rule);

//     return { isValid, rules, expiryDays, maxFailedAttempts, lockoutDuration, passwordReuseLimit };

// };


// const validateUserForm = (data: any) => {
//     let formErrors: any = {};
//     // Mobile validation
//     if (!validatePhoneNumber(data?.mobile)) {
//         formErrors.mobile = "Mobile number must be a valid 10-digit number.";
//     }

//     if (!data.organisation) {
//         formErrors.organisation = "Organisation is required.";
//     }


//       if (!data.profile) {
//         formErrors.profile = "Profile is required.";
//     }

//     // Email validation
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data?.email)) {
//         formErrors.email = "Please enter a valid email address.";
//     }

//     // First Name validation
//     if (!/^[a-zA-Z\s]+$/.test(data?.first_name?.trim())) {
//         formErrors.first_name = "First name must contain only letters.";
//     }

//     // Last Name validation
//     if (!/^[a-zA-Z\s]+$/.test(data?.last_name?.trim())) {
//         formErrors.last_name = "Last name must contain only letters.";
//     }

//     // Username validation
//     if (!data?.username?.trim()) {
//         formErrors.username = "User name is required.";
//     }

//     const { isValid, rules } = validatePassword(data?.password, data?.username || "");

//     if (!isValid) {
//         formErrors.password = "Password does not meet all requirements";
//     }


//     // if (!/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()])[A-Za-z\d!@#$%^&*()]{12,}$/.test(data?.password)) {
//     //     formErrors.password = "Password must be at least 12 characters long, include one uppercase letter, one lowercase letter, one number, and one special character.";
//     // }

//     // // Restrict common words in password
//     // const commonWords = ["password", "admin", "welcome", "test@123", "admin@123"];
//     // if (commonWords.some((word) => data?.password.toLowerCase().includes(word))) {
//     //     formErrors.password = "Password must not include common words (e.g., 'password', 'admin').";
//     // }
//     // const fieldsToCheck = [
//     //     { field: data?.username, name: "Username" },
//     //     // { field: data?.first_name, name: "First Name" },
//     //     // { field: data?.last_name, name: "Last Name" },
//     // ];

//     // for (const { field, name } of fieldsToCheck) {
//     //     if (field) {
//     //         const error = hasConsecutiveSubstring(data?.password, field?.toLowerCase(), name);
//     //         if (error) {
//     //             formErrors.password = error;
//     //             break;
//     //         }
//     //     }
//     // }

//     if (data?.password !== data?.confirm_password) {
//         formErrors.confirm_password = "Passwords do not match.";
//     }
//     return formErrors;
// };

// const validateOrganisationForm = (data: any) => {
//     let formErrors: any = {};
//     if (!validatePhoneNumber(data?.phone)) {
//         formErrors.phone = "Mobile number must be a valid 10-12 digit number.";
//     }
//     if (!data?.name) {
//         formErrors.name = "Name is required.";
//     }
//     if (!data?.category) {
//         formErrors.category = "Category is required.";
//     }
//     if (!data?.business_type || data?.business_type?.length === 0) {
//         formErrors.business_type = "Business Type is required.";
//     }
//     if (!data?.business_subtype || data?.business_subtype?.length === 0) {
//         formErrors.business_subtype = "Business Sub Type is required.";
//     }
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data?.email)) {
//         formErrors.email = "Please enter a valid email address.";
//     }
//     // setOrganisationFormDataErrors(formErrors);
//     return formErrors
//     // return Object.keys(formErrors).length === 0;
// };

// const validateProfileForm = (data: any) => {
//     let formErrors: any = {};
//     if (!data?.new_name) {
//         formErrors.new_name = "New name is required.";
//     }
//     if (!data?.clone_from_profile_id) {
//         formErrors.clone_from_profile_id = "Profile is required.";
//     }
//     if (!data?.new_organisation_id) {
//         data.new_organisation_id = "Organisation is required";
//     }
//     // setProfileFormDataErrors(formErrors);
//     return formErrors;

// }

// const validateMappingForm = (data: any) => {
//     console.log(data, "24")
//     let formErrors: any = {};
//     if (!data?.firstOrganisation) {
//         formErrors.firstOrganisation = "Source organisation is required";
//     }
//     if (!data?.secondOrganisation) {
//         formErrors.secondOrganisation = "Organisation is required";
//     }
//     return formErrors;
// }


// export {
//     validateUserForm,
//     validateProfileForm,
//     validateOrganisationForm,
//     validateMappingForm,
//     validatePassword
// }


const validatePhoneNumber = (phone: string) => {
    const phoneRegex = /^([1-9]{1}[0-9]{1,14})$/;
    return phoneRegex.test(phone);
};

const hasConsecutiveSubstring = (str: string, source: string) => {
    for (let i = 0; i < source.length - 2; i++) {
        const substring = source.substring(i, i + 3);
        if (str.toLowerCase().includes(substring.toLowerCase())) {
            return false;
        }
    }
    return true;
};

const validatePassword = (password: string, username: string = "", passwordHistory: string[] = []) => {
    const commonWords = [
        "password", "admin", "welcome", "test123", "admin123", "qwerty", "letmein", "monkey",
        "abc123", "123456", "12345678", "iloveyou", "sunshine", "princess", "football", "charlie",
        "donald", "freedom", "hello", "whatever", "superman", "trustno1", "jordan", "killer",
        "summer", "computer", "batman", "qazwsx", "zaq1zaq1", "passw0rd", "baseball", "soccer"
    ];

    const minLength = 12;
    const passwordReuseLimit = 8;
    const normalizedUsername = (username || '').trim().toLowerCase();
    const usernameFragment = normalizedUsername.length >= 4
        ? normalizedUsername.slice(0, Math.min(5, normalizedUsername.length))
        : '';

    const rules = {
        minLength: password?.length >= minLength,
        uppercase: /[A-Z]/.test(password),
        lowercase: /[a-z]/.test(password),
        number: /\d/.test(password),
        // specialChar: /[!@#$%^&*()]/.test(password),
        specialChar: /[^\w\s]/.test(password),
        noCommonWords: !commonWords?.some(word => password?.toLowerCase()?.includes(word)),
        noUsernameSubstring: !usernameFragment || !password?.toLowerCase()?.includes(usernameFragment),
        // notInHistory: !passwordHistory.includes(password),
        // noConsecutiveSubstring: username ? hasConsecutiveSubstring(password, username) : true
    };

    const isValid = Object.values(rules).every(rule => rule);

    return { isValid, rules };
};

const validateUserForm = (data: any) => {
    let formErrors: any = {};

    if (!validatePhoneNumber(data?.mobile)) {
        formErrors.mobile = "Mobile number must be a valid 10-digit number.";
    }

    if (!data.organisation) {
        formErrors.organisation = "Organisation is required.";
    }

    if (!data.profile) {
        formErrors.profile = "Profile is required.";
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data?.email)) {
        formErrors.email = "Please enter a valid email address.";
    }

    if (!/^[a-zA-Z\s]+$/.test(data?.first_name?.trim())) {
        formErrors.first_name = "First name must contain only letters.";
    }

    if (!/^[a-zA-Z\s]+$/.test(data?.last_name?.trim())) {
        formErrors.last_name = "Last name must contain only letters.";
    }

    if (!data?.username?.trim()) {
        formErrors.username = "User name is required.";
    }

    // const { isValid, rules } = validatePassword(data?.password, data?.username || "", data?.passwordHistory || []);

    // if (!isValid) {
    //     formErrors.password = "Password does not meet all requirements.";
    // }

    // if (data?.password !== data?.confirm_password) {
    //     formErrors.confirm_password = "Passwords do not match.";
    // }

    // if (data?.password?.trim() !== data?.confirm_password?.trim()) {
    //     formErrors.confirm_password = "Passwords do not match.";
    // }


    return formErrors;
};

const validateOrganisationForm = (data: any) => {
    let formErrors: any = {};

    if (!validatePhoneNumber(data?.phone)) {
        formErrors.phone = "Mobile number must be a valid 10-12 digit number.";
    }

    if (!data?.name) {
        formErrors.name = "Name is required.";
    }

    if (!data?.category) {
        formErrors.category = "Category is required.";
    }

    if (!data?.business_type || data?.business_type?.length === 0) {
        formErrors.business_type = "Business Type is required.";
    }

    if (!data?.business_subtype || data?.business_subtype?.length === 0) {
        formErrors.business_subtype = "Business Sub Type is required.";
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data?.email)) {
        formErrors.email = "Please enter a valid email address.";
    }

    return formErrors;
};

const validateProfileForm = (data: any) => {
    let formErrors: any = {};

    if (!data?.new_name) {
        formErrors.new_name = "New name is required.";
    }

    if (!data?.clone_from_profile_id) {
        formErrors.clone_from_profile_id = "Profile is required.";
    }

    if (!data?.new_organisation_id) {
        formErrors.new_organisation_id = "Organisation is required.";
    }

    return formErrors;
};

const validateMappingForm = (data: any) => {
    let formErrors: any = {};

    if (!data?.firstOrganisation) {
        formErrors.firstOrganisation = "Source organisation is required.";
    }

    if (!data?.secondOrganisation) {
        formErrors.secondOrganisation = "Organisation is required.";
    }

    return formErrors;
};


const validateBulkUpload = ({
    file,
    selectedBoard,
    selectedClass,
    selectedSubject,
}: {
    file: File | null;
    selectedBoard: string;
    selectedClass: string;
    selectedSubject: string;
}) => {
    let errors: any = {};

    if (!file) {
        errors.file = "Please select an Excel file.";
    }

    const validTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
    ];

    if (file && !validTypes.includes(file.type)) {
        errors.file = "Only .xlsx or .xls files are allowed.";
    }

    // ✅ file size validation (max 5MB example)
    const maxSize = 5 * 1024 * 1024;
    if (file && file.size > maxSize) {
        errors.file = "File size should be less than 5MB.";
    }

    // if (!selectedBoard) {
    //     errors.board = "Board is required.";
    // }

    // if (!selectedClass) {
    //     errors.class = "Class is required.";
    // }

    // if (!selectedSubject) {
    //     errors.subject = "Subject is required.";
    // }

    return errors;
};

export {
    validateUserForm,
    validateProfileForm,
    validateOrganisationForm,
    validateMappingForm,
    validatePassword,
    validateBulkUpload
};
